module.exports = __webpack_public_path__ + "static/media/pavo_tex.2be1b759.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/pavo/pavo_tex.png
// module id = 149
// module chunks = 0